
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    isCart: { type: Boolean, default: false },
    redeemed_discount: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      itemPromotionBanner: [],
      overlayImagesItemsPromotion: [],
      head_title: '',
      head_desc: '',
      toastData: {
        title: '',
        desc: '',
      },
    }
  },
  computed: {
    ...mapGetters('authen', ['openId']),
    ...mapGetters('user', ['userProfile', 'profileType', 'userCostcenter']),
    ...mapGetters('cart', ['cartId']),
  },
  watch: {
    redeemed_discount: {
      handler: function (val) {
        if (
          val?.toast_message?.title?.[this.$i18n.locale] &&
          val?.toast_message?.description?.[this.$i18n.locale]
        ) {
          // if (
          //   this.head_title !== val.toast_message.title[this.$i18n.locale] ||
          //   this.head_desc !== val.toast_message.description[this.$i18n.locale]
          // ) {
          this.head_title = val.toast_message.title[this.$i18n.locale]
          this.head_desc = val.toast_message.description[this.$i18n.locale]
          this.onToast(this.head_title, this.head_desc)
          // }
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    console.log('redeemed_discount', this.redeemed_discount)
    // await this.onGetPWPItems()
    // let title = `ยินดีด้วย คุณได้รับ ${this.total} สิทธิ์แลกซื้อ`
    // let desc = `สิทธิ์แลกซื้อสำหรับลูกค้าออนไลน์ และใช้ได้ภายในคำสั่งซื้อเดียวกันเท่านั้น เริ่มใช้สิทธิ์สุดคุ้มเลย!`
    // if (
    //   this.redeemed_discount?.toast_message?.title?.[this.$i18n.locale] &&
    //   this.redeemed_discount?.toast_message?.description?.[this.$i18n.locale]
    // ) {
    //   this.head_title =
    //     this.redeemed_discount.toast_message.title[this.$i18n.locale]
    //   this.head_desc =
    //     this.redeemed_discount.toast_message.description[this.$i18n.locale]
    //   this.onToast(this.head_title, this.head_desc)
    // }
    // this.$bvToast.show('my-toast')
  },
  methods: {
    // onTestUpdateToast() {
    //   let desc = this.$t('pwp.pwp_toast_title_1', {
    //     total: this.redeemed_discount?.privilege?.limit,
    //   })
    //   let title = this.$t('pwp.pwp_toast_desc_1')
    //   this.onToast(title, desc)
    // },

    // async onGetPWPItems() {
    //   await this.$shoppingCartProvider
    //     .getPWPCart(this.openId, this.userProfile.id)
    //     .then(
    //       async (result) => {
    //         if (result.status === 200) {
    //           let data = result.data
    //           this.redeemed_discount = result.data[0]
    //           // gtm GA4
    //           // this.$gtm.push({ ecommerce: null })
    //           // this.$gtm.push({
    //           //   event: 'view_item_list',
    //           //   ecommerce: {
    //           //     user: this.$store.getters['user/userInfoTrack'],
    //           //     item_list_id: 'promotions',
    //           //     item_list_name: 'promotions',
    //           //     items: this.itemsPWP.map((item, index) => {
    //           //       const sku = item.skus[0]
    //           //       return {
    //           //         item_id: sku.sku_code,
    //           //         item_name: sku.product_names[1]?.display_name.th,
    //           //         index: index,
    //           //         price: sku.price_include_vat,
    //           //         discount:
    //           //           sku.retail_price.include_vat - sku.price_include_vat,
    //           //         item_list_id: 'promotions',
    //           //         item_list_name: 'promotions',
    //           //         ...this.$store.getters['user/userPromotionTrack'],
    //           //       }
    //           //     }),
    //           //   },
    //           // })
    //           // }
    //         }
    //       },
    //       (error) => {
    //         console.log('getPromotionProduct', error.responsed)
    //       }
    //     )
    // },
    // onToast(toast_title, toast_desc) {
    //   const id = 'pwp-toast'

    //   // Track toast state in the component instance
    //   // if (!this._toastData) {
    //   //   this._toastData = this.$root.$data._toastData =
    //   //     this.$root.$data._toastData ||
    //   //     this.$set(this.$root.$data, '_toastData', {
    //   //       title: title,
    //   //       desc: desc,
    //   //     })
    //   // } else {
    //   //   // Update values
    //   //   this._toastData.title = title
    //   //   this._toastData.desc = desc
    //   // }

    //   this.toastData.title = toast_title
    //   this.toastData.desc = toast_desc
    //   // Check if toast is currently visible
    //   const existingToast = document.getElementById(id)

    //   // If toast is NOT visible, show it again
    //   if (!existingToast) {
    //     const headerContent = this.$createElement({
    //       data: () => this.toastData,
    //       render(h) {
    //         return h(
    //           'div',
    //           {
    //             class: 'd-flex align-items-center justify-content-between',
    //             attrs: { id },
    //           },
    //           [
    //             h('div', { class: 'd-flex' }, [
    //               h('div', { class: 'head-pwp-toast' }, [
    //                 h('div', { class: 'flex-center 56px' }, [
    //                   h('img', {
    //                     attrs: {
    //                       src: 'https://ofm-cdn0.ofm.co.th/images/pwp-icons.png',
    //                       width: '36px',
    //                       height: '36px',
    //                     },
    //                   }),
    //                 ]),
    //               ]),
    //               h('div', { class: 'head-pwp-body' }, [
    //                 h('div', { class: 'fs-14 fw-bold' }, [this.title]),
    //                 h('div', { class: 'fs-11' }, [this.desc]),
    //               ]),
    //             ]),
    //             h('b-icon-x', {
    //               class: ['ml-auto mb-auto m-1 fs-20 pointer'],
    //               on: {
    //                 click: () => {
    //                   this.$bvToast.hide(id)
    //                 },
    //               },
    //             }),
    //           ]
    //         )
    //       },
    //     })

    //     this.$bvToast.toast([headerContent], {
    //       id,
    //       append: false,
    //       // noAutoHide: true,
    //       toaster: 'b-toaster-top-right pwp-toast',
    //       noCloseButton: true,
    //       autoHideDelay: 5000,
    //     })
    //   }
    // },
    onToast(title, desc) {
      const id = 'pwp-toast'

      // Update toast data
      this.toastData.title = title
      this.toastData.desc = desc

      // If toast is visible, hide it first
      const existingToast = document.getElementById(id)
      if (existingToast) {
        this.$bvToast.hide(id) // hide current one
        setTimeout(() => this.showToast(id), 10) // slight delay to re-show
      } else {
        this.showToast(id)
      }
    },

    showToast(id) {
      const toastData = this.toastData

      const headerContent = this.$createElement({
        data() {
          return toastData
        },
        render(h) {
          return h(
            'div',
            {
              class: 'd-flex align-items-center justify-content-between',
              attrs: { id },
            },
            [
              h('div', { class: 'd-flex' }, [
                h('div', { class: 'head-pwp-toast' }, [
                  h('div', { class: 'flex-center 56px' }, [
                    h('img', {
                      attrs: {
                        src: 'https://ofm-cdn0.ofm.co.th/images/pwp-icons.png',
                        width: '36px',
                        height: '36px',
                      },
                    }),
                  ]),
                ]),
                h('div', { class: 'head-pwp-body' }, [
                  h('div', { class: 'fs-14 fw-bold' }, [this.title]),
                  h('div', { class: 'fs-11' }, [this.desc]),
                ]),
              ]),
              h('b-icon-x', {
                class: ['ml-auto mb-auto m-1 fs-20 pointer'],
                on: {
                  click: () => this.$bvToast.hide(id),
                },
              }),
            ]
          )
        },
      })

      this.$bvToast.toast([headerContent], {
        id,
        append: false,
        toaster: 'b-toaster-top-right pwp-toast',
        noCloseButton: true,
        autoHideDelay: 5000, // Reset on each call
      })
    },
  },
}
